import * as React from 'react';
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {
  addBox,
  addFruit,
  addShelf, changeTreeMapped,
  IAddBoxPayload,
  IAddFruitPayload,
} from "src/store/actions";
import {TActions} from "src/store/models";
import {getId} from "src/utils/utils";

type TProps = IDispatchToProps;

class FruitShelf extends React.Component<TProps, {}> {
  private id = getId('FruitShelf');

  public componentWillMount() {
    this.props.addShelf(this.id);
  }

  public componentDidMount() {
    this.props.changeTreeMapped();
  }

  public render() {
    const {children, ...otherProps} = this.props;
    return (
      <>
        {React.Children.map(children, (child: any) => React.cloneElement(child, {...otherProps, shelfId: this.id}))}
      </>
    );
  }
}

interface IDispatchToProps {
  addBox: (payload: IAddBoxPayload) => void;
  addFruit: (payload: IAddFruitPayload) => void;
  addShelf: (ID: string) => void;
  changeTreeMapped: () => void;
}


export const mapDispatchToProps = (dispatch: Dispatch<TActions>): IDispatchToProps => ({
  addBox: (payload: IAddBoxPayload) => dispatch(addBox(payload)),
  addFruit: (payload: IAddFruitPayload) => dispatch(addFruit(payload)),
  addShelf: (id: string) => dispatch(addShelf(id)),
  changeTreeMapped: () => dispatch(changeTreeMapped())
});

const connected = connect(null, mapDispatchToProps)(FruitShelf);
export {connected as FruitShelf};


// WEBPACK FOOTER //
// ./src/containers/abstract/FruitShelf.tsx